import { Component, inject, Input } from '@angular/core';
import { AlertService } from '@ose/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-copy-button',
  standalone: true,
  templateUrl: './copy-button.component.html',
  styleUrl: './copy-button.component.scss',
})
export class CopyButtonComponent {
  @Input({ required: true })
  value: string | null | undefined = '';

  private readonly alertService = inject(AlertService);
  private readonly translate = inject(TranslateService);

  async copy(): Promise<void> {
    if (!this.value) {
      return;
    }

    try {
      await navigator.clipboard.writeText(this.value);

      this.alertService.showToast({
        body: this.translate.instant('SuccessCopy'),
        type: 'success',
      });
    } catch {
      this.alertService.showToast({
        body: this.translate.instant('CopyFailed'),
        type: 'danger',
      });
    }
  }
}
